<template>
  <div
    v-editable="blok"
    :class="isSticky ? 'social-links--sticky' : ''"
    class="social-links"
  >
    <ul class="social-links__list">
      <li
        v-for="link in links"
        :key="link.index"
        class="social-links__list-item"
      >
        <a
          v-if="link.url"
          v-editable="blok"
          :href="link.url"
          :class="'social-links__link icon icon--' + link.name"
        >
          <span class="social-links__text">{{ link.name }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SocialLinks',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      links: [
        {
          name: 'linkedin',
          url: '',
        },
        {
          name: 'twitter',
          url: 'https://twitter.com/share',
        },
        {
          name: 'facebook',
          url: '',
        },
      ],
    }
  },
  mounted() {
    this.getLinkedInUrl()
    this.getFacebookUrl()
  },
  methods: {
    getLinkedInUrl() {
      /* eslint-disable */
      const base = 'https://www.linkedin.com/shareArticle?mini=true'
      const pageUrl = '&url=' + window.location.href
      const title = '&title=' + encodeURIComponent(this.blok.title)
      const source = '&source=Tribal%20Worldwide%20London'

      this.links[0].url = base + pageUrl + title + source
    },
    getFacebookUrl() {
      const base = 'http://www.facebook.com/share.php?'
      const pageUrl = 'u=' + window.location.href

      this.links[2].url = base + pageUrl
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.social-links {
  background: $tribal-white;

  &__list {
    list-style: none;
    padding: 30px;
    margin: 0;
    display: flex;
    justify-content: flex-end;
  }

  &__list-item {
    background-color: $white;
    background-position: 50%;
    background-repeat: no-repeat;
    border: 1px solid $swirl;
    border-radius: 50%;
    display: block;
    height: 54px;
    transition: all 0.3s ease-in-out;
    width: 54px;
    margin: 0 10px 10px;

    &:hover {
      background-color: $oslo-gray;

      .social-links__link {
        &::before {
          color: $white;
        }
      }
    }
  }

  &__link {
    display: block;
    height: 100%;
    width: 100%;

    &::before {
      @include font-size(54, rem-v(50));

      color: $oslo-gray;
      vertical-align: bottom;
    }
  }

  &__text {
    font-size: 0;
  }
}

@media (min-width: 1350px) {
  .social-links {
    background: transparent;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;

    &--sticky {
      position: fixed;
      top: 70px;
    }

    &__list {
      display: block;
    }
  }
}
</style>
